import { Filter } from './filter.js';
export class LuminosityContrastFilter extends Filter {
    _luminosity: number;
    _contrast: number;
    _radius: number;
    _advanced: boolean;
    minLuminosity: number;
    maxLuminosity: number;
    minContrast: number;
    maxContrast: number;
    minRadius: number;
    maxRadius: number;


    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'luminosityContrast', 'Luminosité/Contraste');
        this.reset();
    }

    get luminosity() {
        return this._luminosity;
    }

    set luminosity(value) {
        var self = this;
        self._luminosity = value;
        self._touch = true;
    }

    get contrast() {
        return this._contrast;
    }

    set contrast(value) {
        var self = this;
        self._contrast = value;
        self._touch = true;
    }

    get radius() {
        return this._radius;
    }

    set radius(value) {
        var self = this;
        self._radius = value;
        self._touch = true;
    }

    get advanced() {
        return this._advanced;
    }

    set advanced(value) {
        var self = this;
        self._advanced = value;
        self._radius = 0;
        self._contrast = 0;
        self._touch = true;
    }

    reset() {
        var self = this;
        self._touch = true;
        self._luminosity = 0;
        self.minLuminosity = -150;
        self.maxLuminosity = 150;

        self._contrast = 0;
        self.minContrast = -50;
        self.maxContrast = 100;

        self._radius = 0;
        self.minRadius = 0;
        self.maxRadius = 10;

        self._advanced = false;
    }

}
